import { cloneElement } from 'react';

import styles from './ConfirmationQuestion.module.css';

export const ConfirmationQuestion = (props) => {
    const { children, onSubmit, onCancel, showQuestion, showQuestionHandler } =
        props;

    if (!showQuestion) {
        return null;
    }

    const question = cloneElement(children[0]);
    const confirmButton = cloneElement(children[1], {
        onSubmit: onSubmit
    });
    const cancelButton = cloneElement(children[2], {
        onCancel: onCancel,
        showQuestionHandler: showQuestionHandler
    });

    return (
        <div className={styles.ConfirmationQuestion}>
            <div className={styles.ConfirmationQuestionText}>{question}</div>
            <div className={styles.ConfirmationQuestionActions}>
                {confirmButton}
                {cancelButton}
            </div>
        </div>
    );
};
